import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import Portlet from './Portletcomponents/Portlet';
import PortletHeader from './Portletcomponents/PortletHeader';
import PortletContent from './Portletcomponents/PortletContent';
import PortletFooter from './Portletcomponents/PortletFooter';

//import Filter from './FilterService'
// Material components
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CardContent from '@material-ui/core/CardContent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import AddAlarmIcon from '@material-ui/icons/AddAlarm';
import moment from 'moment'
import 'moment/locale/es'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {api_auth} from './../../../../common/constants'
import styles from './styles';

import ObjectiveGroups from './ObjectiveGroups';
import Incidents from './Incidents'
import PanelAvailability from './PanelAvailability'

moment.locale('es')
// Browser history
const browserHistory = createBrowserHistory()


//BASE QUE RECIBE DATA Y GENERAR GRUPOS
class Base extends Component {
    constructor(props) {
        super(props)
        //console.log(props)
        this.InfoObjective = this.InfoObjective.bind(this);
        //this.dataGroupColor = this.dataGroupColor.bind(this);
        this.state = {
            isLoading: true,
            //GRUPOS CON TITULO E IMAGEN
            dataGroups:this.props.data,
            //GRUPOS SIN TITULO NI IMAGEN
            groups:[],
            namesGroup:[],
            namesGroupStatic:[],
            staticGroups:[],
            listObjectivesByObjectives:[],
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            estados:[{nombre:'Uptime'}, {nombre:'Downtime'}],
            estadosStatic:[{nombre:'Uptime'}, {nombre:'Downtime'}],
            maxObjs:0,
        }
    }

    componentDidMount() {
        this.processData();
    }

    /*static getDerivedStateFromProps( prevState, state) {
        const {data:{imagen, titulo,...data}}=prevState
        console.log('derived', data, state.groups)
        if( data!== state.groups){
            return{
                groups:state.groups,
            } 
        }
        return null
    }*/

    componentDidUpdate(prevProps, prevState) {
        if(this.state.dateMoment!== prevState.dateMoment){
            this.processData();
        }
    }


    processData(){
        //console.log('process base')
        const {dataGroups: {imagen,titulo, ...dataGroups}} = this.state;
        var namesGroup=[]
        Object.keys(dataGroups).map(ele=>{
            namesGroup.push({"titulo_grupo":dataGroups[ele].titulo_grupo, "grupo":ele})
        })
        //CUENTA TOTAL DE OBJETIVOS
        var maxObjs=0
        Object.keys(dataGroups).map(ele=>{
            Object.keys(dataGroups[ele]).map(objs=>{
                if(objs!=="titulo_grupo"){
                    if(objs!=="orden_grupo"){
                        //console.log(groups[ele][objs])
                        maxObjs=maxObjs+1
                    }
                }
            })
        })
        this.interval = setInterval(() =>
             this.setState({ 
                 dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")) 
            }),300000)
        //console.log(maxObjs)
        this.setState({
            isLoading:false,
            groups:dataGroups,
            namesGroup:namesGroup,
            staticGroups:dataGroups,
            namesGroupStatic:namesGroup,
            maxObjs:maxObjs
        })
    }

    InfoObjective=(value)=>{
        const {groups, maxObjs} = this.state;

        this.setState(prevValue=>({ 
            listObjectivesByObjectives:[...prevValue.listObjectivesByObjectives,value]
        }))
        
        if(this.state.listObjectivesByObjectives.length<=maxObjs){
            sessionStorage.setItem("loadMax", "true")
            if(this.state.listObjectivesByObjectives.length=== maxObjs){
                //console.log(listObjectivesByObjectives)
                //console.log(groups)
                Object.keys(groups).map(ele=>{
                    //console.log(groups[ele])
                    var contColor=0
                    Object.keys(groups[ele]).map(objs=>{
                        if(objs!=="titulo_grupo"){
                            if(objs!=="orden_grupo"){
                                //console.log(groups[ele][objs].color)
                                if(groups[ele][objs].color!=='#41B900'){
                                    //console.log('sf')
                                    contColor=contColor+1
                                }
                            }
                        }
                    })
                    var color="#41B900";


                    /* if(contColor>0){
                        color="#C2272D"
                    } */

                    // LÓGICA ESPECIAL AFP HABITAT
                    let objetivesCount = Object.keys(groups[ele]).filter( v => parseInt(v)).length + 1;
                    let downtimeObjectivesPercent = parseInt((contColor / objetivesCount) * 100)
                    
                    /* console.log("objetivesCount:", objetivesCount )
                    console.log("contColor:", contColor)
                    console.log("downtimeObjectivesPercent:", downtimeObjectivesPercent ) */

                    if (downtimeObjectivesPercent > 50 )
                    {
                        color="#C2272D";
                    }
                    else if (downtimeObjectivesPercent <= 50 && downtimeObjectivesPercent > 10 )
                        color="#FFCA33";

                    groups[ele]["colorGroup"]=color;
                    
                })
                //console.log('info' , groups)
                this.setState({
                    groups:groups,
                })
            }
        }
    }

    filterNameGroups=(event, value)=>{
        const {staticGroups, estados}=this.state
        //console.log('grupos',staticGroups)
        //console.log(value)
        var dataFilterGroups=[]
        
        //VARIABLES PARA GUARDAR GRUPOS EN FILTRO POR ESTADO
        var colorService=[]
        var primero=true
        var colorGroupFilter=""
        value.map(filterGroup=>{
            Object.keys(staticGroups).map(group=>{
                if(group===filterGroup.grupo){
                    // SI FILTRA POR GRUPO QUE GUARDE ESTADOS DE ESOS GRUPOS
                    if(primero===true){
                        if(staticGroups[group].colorGroup==='#C2272D'){
                            colorService.push({nombre:"Downtime"})
                        }else{
                            colorService.push({nombre:"Uptime"})
                        }
                        colorGroupFilter=staticGroups[group].colorGroup
                        //console.log('primero', colorGroupFilter)
                        primero=false
                    }else{
                        //console.log('segundo', colorGroupFilter, staticGroups[group].colorGroup)
                        if(colorGroupFilter!==staticGroups[group].colorGroup){
                            if(staticGroups[group].colorGroup==='#C2272D'){
                                colorService.push({nombre:"Downtime"})
                            }else{
                                colorService.push({nombre:"Uptime"})
                            } 
                        }
                    }
                    
                    //console.log(staticGroups[group].colorGroup)
                    //newNameGroup.push({"titulo_grupo":staticGroups[group].titulo_grupo, "grupo":group})
                    dataFilterGroups.push(staticGroups[group])
                }
            })
        })
        //console.log(colorService)
        //console.log(dataFilterGroups)
        if(dataFilterGroups.length!==0){
            //console.log('filter', dataFilterGroups)
            this.setState({
                groups:dataFilterGroups,
                estados:colorService
                //namesGroup:newNameGroup,
            })
        }else{
            //console.log('nada')
            this.setState({
                groups:staticGroups,
                estados:estados
            })
        }
    }

    filterStatusGroups=(event, value)=>{
        const {staticGroups, groups, namesGroup, namesGroupStatic, estados, estadosStatic}=this.state
        //console.log(filterGroup)
        //console.log('grupos estaticos',groups)
        //console.log(namesGroup)
        //console.log(estados)
        var newNamesGroups=[]
        if(value.length!==2&&value.length!==0){
            var dictNew={}
            Object.keys(staticGroups).map(ele=>{
                //console.log(staticGroups[ele].colorGroup, value[0].nombre)
                if(value[0].nombre==="Uptime"&&staticGroups[ele].colorGroup==="#41B900"){
                    dictNew[ele]=(staticGroups[ele])
                    //console.log(ele)
                    namesGroup.map(groupName=>{
                        //console.log('nombre grupos', groupName.grupo)
                        if(ele===groupName.grupo){
                            newNamesGroups.push(groupName)
                        }
                    })
                    
                }
                if(value[0].nombre==="Downtime"&&staticGroups[ele].colorGroup==="#C2272D"){
                    dictNew[ele]=(staticGroups[ele])
                    namesGroup.map(groupName=>{
                        //console.log('nombre grupos', groupName.grupo)
                        if(ele===groupName.grupo){
                            newNamesGroups.push(groupName)
                        }
                    })
                }
                
            })
            //console.log('nuevos nombres', newNamesGroups)
            this.setState({
                groups:dictNew,
                namesGroup:newNamesGroups
            })
        }else{
            
            this.setState({
                groups:staticGroups,
                namesGroup:namesGroupStatic,
                estados:estadosStatic
            })
        }
    }

    //FUNCION QUE CONTROLA DATOS QUE SE ENVIARAN EN EL RENDER
    Graph=(classes, groups, namesGroup, estados, date)=>{
        //console.log('r_base', groups, namesGroup)
        var topGrid="0%"
            if(window.innerWidth<500 && window.innerWidth>=400){
                topGrid="7%"
            }
            if(window.innerWidth<400 && window.innerWidth>0){
                topGrid="17%"
            }
        var graph=  
            <CardContent>
                
                <Grid
                container
                direction="row"
                justify="center"
                //alignItems="center"
                >
                    {(Object.keys(groups).map(ele=>(
                        <Grid item lg={3} md={3} xl={3} key={ele} className={classes.gridItem}>
                            <ObjectiveGroups data={groups[ele]} InfoObjective={this.InfoObjective}/>
                        </Grid>
                    )))} 
                </Grid>
                <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    style={{paddingTop:topGrid}}
                    //alignItems="center"
                >
                    
                    <Grid item sm={12}  lg={4} xl={4} 
                         //className={classes.gridItem}
                    >
                        {/* Agrega Panel Informativo */}
                        <div style={{ 
                                    display: 'flex',
                                    alignItems: 'right',
                                    paddingLeft: '10px'}} >
                        <b>Información: </b>
                            
                                <FiberManualRecordIcon style={{ color: "rgb(65, 185, 0)"}} />
                            
                                <div className={classes.infoText}>Operativo (verificado desde todos los ISP)&nbsp;</div>

                                <FiberManualRecordIcon style={{ color: "yellow"}} />
                    
                                <div className={classes.infoText}>Operativo (algunos ISP con problemas)&nbsp;</div>

                            
                                <FiberManualRecordIcon style={{ color: "rgb(194, 39, 45)"}} />
                            
                                <div className={classes.infoText}>Caído o No Operativo.&nbsp;</div>

                                <FiberManualRecordIcon style={{ color: "gray"}} />
                    
                                <div className={classes.infoText}>Sin Monitoreo&nbsp;</div>
                        </div>
                    </Grid>
                    <Grid item sm={12} lg={3} xl={3} style={{textAlign:"center"}}>
                        <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        //alignItems="center"
                        >
                            <Grid item lg={6} xl={6}  style={{textAlign:"right"}}>
                                <Typography><AddAlarmIcon/></Typography>
                            </Grid>
                            <Grid item lg={6} xl={6} className={classes.rem} style={{textAlign:"left"}}>
                                <Typography style={{paddingLeft:"8px"}} variant="caption">Última Actualización:{date}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    
                </Grid>
                
            </CardContent>
        return graph
    }

    getContent(groups, namesGroup, estados, dateMoment){
        //@TODO hacer implementación con React Router
        const {classes}=this.props
        var content=<Router history={browserHistory} exact path="/">
                        <Card >
                            {this.Graph(classes, groups, namesGroup, estados, dateMoment)}
                        </Card>
                    </Router>
        return content
    }

    render() {
        const {isLoading, groups, namesGroup, estados, dateMoment}=this.state
        //console.log('send base', estados)
        const {classes}=this.props
        //console.log(isLoading)
        //console.log(listObjectives.length, countAllObjectives, colorGroup)
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let token = params.get('token');

        if (isLoading===true ) {
            return(
                <Grid container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.contentCircular}>
                    <Grid item lg={12} xl={12}>
                        <Typography
                        className={classes.circular}
                            variant="h2"
                            >
                            <CircularProgress
                            className={classes.circular}
                            variant="indeterminate"
                            size={80}
                            thickness={3}
                            
                            />
                            Cargando Grupos...
                        </Typography>
                    </Grid>
                </Grid>
            )
        }else if(api_auth!==token){
            return(
                <Grid 
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    className={classes.contentCircular}
                >
                    <Grid item lg={12} xl={12}>
                        <Typography
                            variant="h6"
                            style={{color:'red'}}
                            >

                            Error: Token de acceso no válido!
                        </Typography>
                    </Grid>
                </Grid>
            )
        }else{
            
            return(
                <Grid
                    
                    container
                    spacing={2}
                    direction="row"
                    justify="center"
                    alignItems="baseline"
                >
                    <Grid item lg={12} xl={12}>
                        {this.getContent(groups, namesGroup, estados, dateMoment)}
                    </Grid>
                    {/*<Grid item lg={12} xl={12} style={{width:"100%", textAlign:"center",position: "-webkit-sticky", position: "sticky", top:"0px",padding: "40px"}}>
                        <Typography style={{color:"white", backgroundColor:"gray"}} variant="h4">Panel De Incidentes</Typography>
                    </Grid>*/}
                     <PanelAvailability groups={groups} nameGroup={namesGroup} maxObjs={this.state.maxObjs} />   
                    <Incidents groups={groups} nameGroup={namesGroup} maxObjs={this.state.maxObjs}/>
                </Grid>
                
            )
        }

        
    }
}
export default
    compose(withStyles(styles))(Base);
